import { queryOptions } from "@tanstack/react-query";
import type { UpcomingInvoiceResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

const fetchUpcomingInvoice = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<UpcomingInvoiceResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data } = await api.get<UpcomingInvoiceResponse>(
    "/billing/upcoming_invoice"
  );

  return data;
};

export const upcomingInvoiceQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions<UpcomingInvoiceResponse>({
    queryKey: billingKeys.upcomingInvoice(organizationId),
    queryFn: () => fetchUpcomingInvoice({ organizationId }),
  });
